import React__default from 'react';

/**
 * Render an `option` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Option(props) {
    return React__default.createElement("option", { ...props });
}

export { Option };
